import { PRICE_BASE_CHF, PRICE_PER_CM2_CHF } from "@/lib/config";
import { roundTo } from "@/lib/text-metrics";

/**
 * Placeholder pricing formula (base price + area) - not yet confirmed
 * with the client. Tune PRICE_BASE_CHF/PRICE_PER_CM2_CHF in config.ts
 * once a real formula is agreed on; call sites don't need to change.
 */
export function calculatePriceChf(widthCm: number, heightCm: number): number {
  const areaCm2 = widthCm * heightCm;
  return roundTo(PRICE_BASE_CHF + areaCm2 * PRICE_PER_CM2_CHF, 2);
}

export function formatChf(amount: number): string {
  return amount.toLocaleString("de-CH", {
    style: "currency",
    currency: "CHF",
  });
}
